import GengibreCha_15_01_25 from './CardImages/15_01_25_GengibreCha.webp';
import Gengibreplanta_15_01_25 from './CardImages/15_01_25_Gengibreplanta.webp';
import emagrece_15_01_25 from './CardImages/15_01_25_emagrece.webp';
import yogaExercise_16_01_25 from './CardImages/16_01_25_yogaExercise.webp';
import yogaPicture_16_01_25 from './CardImages/16_01_25_yogaPicture.webp';
import mulungu_18_01_25 from './CardImages/18_01_25_mulungu.webp';
import erythrina_18_01_25 from './CardImages/18_01_25_Erythrina_mulungu.webp';
import camomila_18_01_25 from './CardImages/19_01_25_camomila.webp';
import camomilatea_18_01_25 from './CardImages/19_01_25_camomila_tea.webp';
import FruitJuice_18_01_25 from './CardImages/18_01_2025_fruitjUICE.webp';
import Fruits_18_01_25 from './CardImages/18_01_2025_fruits.webp';
import Berries_18_01_25 from './CardImages/18_01_2025_berries.webp';
import Carrots_18_01_25 from './CardImages/18_01_2025_carrot.webp';
import fruitsBanner_18_01_25 from './CardImages/18_01_2025_fruitsBanner.webp'
import VitaminCapsules_18_01_25 from './CardImages/18_01_2025_VitaminCapsules.webp';
import VitaminMedicine_18_01_25 from './CardImages/18_01_2025_vitaminMedicine.webp';
import pumpkinNatural_18_01_25 from './CardImages/18_01_2025_pumpkinNatural.webp';
import pomegranate_18_01_25 from './CardImages/18_01_2025_pomegranate.webp';
import yogaFernanda_16_01_25 from './CardImages/16_01_25_FernandaYoga.webp';
import YogaPos_16_01_25 from    './CardImages/16_01_25_YogaPos.webp';
import SecapsBlack_17_01_25 from './CardImages/17_01_2025_SecapsBlack.webp';
import EmagrecendoSecaps_17_01_25 from './CardImages/17_01_2025_emagrecendoSecaps.webp'
import Exercises_17_01_25 from './CardImages/17_01_2025_exercises.webp'
import SecapsInfo_17_01_25 from './CardImages/17_01_2025_secapsInfo.webp'
import CreatineProteinFormula_24_01_25 from './CardImages/24_01_25_CreatineFormula.webp';
import CreatineProteinMuscle_24_01_25 from './CardImages/24_01_25_CreatineProteinMuscle.webp';
import CreatinaIntegralMedica_24_01_25 from './CardImages/24_01_25_CreatinaIntegralMedica.webp';
import CreatinaMax_24_01_25 from './CardImages/24_01_25_CreatinaMax.webp';
import CreatinaDarkLab_24_01_25 from './CardImages/24_01_25_DarkLabCreatine.webp';
import WheyProteinMuscle_25_01_25 from './CardImages/25_01_25_WheyProteinMuscle.webp';
import WheyProteinPhoto_25_01_25 from './CardImages/25_01_25_WheyProteinPhoto.webp';
import BodyBuildersGoldCan_13_02_25 from './CardImages/13_02_25_BodyBuildersGoldCan_11zon.webp';
import BodyBuildersGold_13_02_25 from './CardImages/13_02_25_BodyBuildersGold_11zon.webp';
import BodyNutriWheyPro_13_02_25 from './CardImages/13_02_25_BodyNutriWheyPro_11zon.webp';
import DarkLab_13_02_25 from './CardImages/13_02_25_DarkLab_11zon.webp';
import SuperWheyMax_13_02_25 from './CardImages/13_02_25_SuperWheyMax_11zon.webp';

export const cardImages = {
    SuperWheyMax_13_02_25,
    DarkLab_13_02_25,
    BodyBuildersGold_13_02_25,
    BodyNutriWheyPro_13_02_25,
    BodyBuildersGoldCan_13_02_25,
    WheyProteinPhoto_25_01_25,
    WheyProteinMuscle_25_01_25,    
    CreatinaIntegralMedica_24_01_25,
    CreatinaMax_24_01_25,
    CreatinaDarkLab_24_01_25,
    CreatineProteinFormula_24_01_25,
    CreatineProteinMuscle_24_01_25,
    mulungu_18_01_25,
    erythrina_18_01_25,
    camomila_18_01_25,
    camomilatea_18_01_25,
    FruitJuice_18_01_25,
    pomegranate_18_01_25,
    Fruits_18_01_25,
    Carrots_18_01_25,
    fruitsBanner_18_01_25,
    Berries_18_01_25,
    pumpkinNatural_18_01_25,
    VitaminMedicine_18_01_25,
    VitaminCapsules_18_01_25,
    GengibreCha_15_01_25,
    Gengibreplanta_15_01_25,
    emagrece_15_01_25,
    yogaExercise_16_01_25,
    yogaPicture_16_01_25,
    yogaFernanda_16_01_25,
    YogaPos_16_01_25,
    SecapsBlack_17_01_25,
    EmagrecendoSecaps_17_01_25,
    Exercises_17_01_25,
    SecapsInfo_17_01_25,

}